import * as React from 'react';
import DesktopFlightModalContent from '@websky/core/src/DesktopFlight/components/DesktopFlightModalContent/DesktopFlightModalContent';
const DesktopFlightRouteModal = props => {
    const tariffsCount = [...props.economyFares, ...props.businessFares, ...props.milesFares].length;
    return (React.createElement(DesktopFlightModalContent, Object.assign({}, props, { sliderSettings: { slidesToShow: !props.isSelectorInModal && tariffsCount >= 4 ? 4 : 3 } })));
};
export default DesktopFlightRouteModal;
